import { green, grey, lightBlue, orange, red } from "@mui/material/colors"
import { BackgroundColorRule, PaletteColorRule, TextColorRule } from "../ColorRules"

export default {
  primary: new PaletteColorRule(lightBlue[50], "#00a1e3", "#243c93", "#ffffff"),
  secondary: new PaletteColorRule(lightBlue[50], "#00a1e3", "#243c93", "#ffffff"),
  error: new PaletteColorRule(red[100], red[500], red[800], "#ffffff"),
  warning: new PaletteColorRule(orange[100], orange[500], orange[800], "#ffffff"),
  info: new PaletteColorRule(grey[100], grey[300], grey[500], grey[800]),
  success: new PaletteColorRule(green[100], green[500], green[800], "#ffffff"),
  text: new TextColorRule("#000000", "#000000", grey[600]),
  divider: "#000000",
  background: new BackgroundColorRule("#ffffff", grey[100])
}